var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { encodeAccountId } from "@ledgerhq/coin-framework/account/index";
import { mergeOps } from "@ledgerhq/coin-framework/bridge/jsHelpers";
import { loadPolkadotCrypto } from "./polkadot-crypto";
export function makeGetAccountShape(polkadotAPI) {
    return (info) => __awaiter(this, void 0, void 0, function* () {
        yield loadPolkadotCrypto();
        const { address, initialAccount, currency, derivationMode } = info;
        const oldOperations = (initialAccount === null || initialAccount === void 0 ? void 0 : initialAccount.operations) || [];
        const startAt = oldOperations.length ? (oldOperations[0].blockHeight || 0) + 1 : 0;
        const { blockHeight, balance, spendableBalance, nonce, lockedBalance, controller, stash, unlockedBalance, unlockingBalance, unlockings, nominations, numSlashingSpans, } = yield polkadotAPI.getAccount(address);
        const accountId = encodeAccountId({
            type: "js",
            version: "2",
            currencyId: currency.id,
            xpubOrAddress: address,
            derivationMode,
        });
        const newOperations = yield polkadotAPI.getOperations(accountId, address, startAt);
        const operations = mergeOps(oldOperations, newOperations);
        const shape = {
            id: accountId,
            balance,
            spendableBalance,
            operationsCount: operations.length,
            blockHeight,
            polkadotResources: {
                nonce,
                controller,
                stash,
                lockedBalance,
                unlockedBalance,
                unlockingBalance,
                unlockings,
                nominations,
                numSlashingSpans,
            },
        };
        return Object.assign(Object.assign({}, shape), { operations });
    });
}
//# sourceMappingURL=js-synchronisation.js.map